import React from 'react';


export default function ProgressBar({ height = '3px', progress, showValue }) {
  const percentage = `${progress}%`;

  return (
    <div className="progress-bar__external" style={{ height, width: '100%' }}>
      <div className="progress-bar__internal" style={{ width: percentage }}>
        {showValue && <span>{percentage}</span>}
      </div>
    </div>
  );
}
